/** Экранирование значений для vCard 3.0 */
function escapeVcard(value) {
    return String(value ?? '')
        .replace(/\\/g, '\\\\')
        .replace(/;/g, '\\;')
        .replace(/,/g, '\\,')
        .replace(/\r?\n/g, '\\n');
}

/** Нормализация телефона для TEL в vCard (международный формат) */
export function normalizePhoneForVcard(phone) {
    if (!phone) return null;
    const digits = String(phone).replace(/\D/g, '');
    if (!digits) return null;

    if (digits.length === 11 && digits.startsWith('8')) {
        return `+7${digits.slice(1)}`;
    }
    if (digits.length === 11 && digits.startsWith('7')) {
        return `+${digits}`;
    }
    if (digits.length === 10) {
        return `+7${digits}`;
    }
    if (digits.length === 12 && digits.startsWith('375')) {
        return `+${digits}`;
    }
    if (digits.length >= 10) {
        return `+${digits}`;
    }
    return null;
}

/**
 * Собирает vCard из списка контактов { name, phone, note? }
 * @returns {string|null} null если нет валидных контактов
 */
export function buildVcard(contacts) {
    const seen = new Set();
    const cards = [];

    for (const contact of contacts) {
        const tel = normalizePhoneForVcard(contact.phone);
        if (!tel || seen.has(tel)) continue;
        seen.add(tel);

        const name = (contact.name || 'Без имени').trim() || 'Без имени';
        cards.push(
            'BEGIN:VCARD',
            'VERSION:3.0',
            `FN:${escapeVcard(name)}`,
            `TEL;TYPE=CELL:${tel}`,
            ...(contact.note ? [`NOTE:${escapeVcard(contact.note)}`] : []),
            'END:VCARD'
        );
    }

    if (cards.length === 0) return null;
    return `${cards.join('\r\n')}\r\n`;
}

/** Скачивание .vcf в браузере */
export function downloadVcard(vcardContent, filename) {
    const blob = new Blob([vcardContent], { type: 'text/vcard;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
